module.exports = __webpack_public_path__ + "img/link-air.6cc0544b.svg";